import React from "react";
import { Helmet } from "react-helmet-async";
import { View } from "./View";
export var Provider = function (_a) {
    var html = _a.html, script = _a.script, displayMode = _a.displayMode, bgColor = _a.bgColor, className = _a.className;
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("script", null, script
                .replace("<script type=\"text/javascript\">", "")
                .replace("</script>", ""))),
        React.createElement(View, { className: className, html: html, displayMode: displayMode, bgColor: bgColor })));
};
